import { ClosurePayment } from '../../util/register-closure-types'

export const filterPaymentTypes = (
  payments: ClosurePayment[],
  outletId: string
) =>
  payments.filter(payment => {
    if (Number(payment.total) > 0) {
      return true
    }

    if (payment.paymentType.disabled) {
      return false
    }

    if (payment.paymentType.outlet_ids === null) {
      return true
    }

    return payment.paymentType.outlet_ids.some(id => id === outletId)
  })
